var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100 orcamento-info-adicional",attrs:{"id":"orcamento-info-adicional"}},[_c('span',{staticClass:"orcamento-info-adicional-icon"},[_vm._v("i")]),_c('span',[_vm._v(" Para enviar o pedido, o valor mínimo deve ser de R$ 600,00, considerando a Quantidade, o Valor unitário dos produtos e a Margem. ")])])
}]

export { render, staticRenderFns }